/** Current year, computed at runtime so year-stamped copy never goes stale. */
export const CURRENT_YEAR = new Date().getFullYear();
